export function scroller():void {
    const elements = document.querySelectorAll('[href="#gotoPostuler"]');
    const target = document.getElementById('gotoPostuler');
    const inputToFocus = document.getElementById('Answer_Firstname');

    for (let i = 0; i < elements.length; i++) {
        elements[i].addEventListener("click", function(e) {
            e.preventDefault();
            
            let behavior: ScrollBehavior = "smooth";
            
            // Bug introduced in Safari 15.4 and fixed in 16.3.
            // We only want Safari 15 to get the direct scrolling.
            // Safari 16 will get the smooth scrolling.
            // https://bugs.webkit.org/show_bug.cgi?id=238497
            if (
                navigator.userAgent.includes("Safari") &&
                navigator.userAgent.includes("Version/15.")
            ) {
                behavior = "auto";
            }
            window.scroll({ top: target.offsetTop - 100, left: 0, behavior: behavior });

            if(inputToFocus) {
                inputToFocus.focus({
                    preventScroll: true
                });
            }            
        })
    }
}